<template>
    <div class="w-full p-4">
        <!-- En-tête -->
        <div class="bg-gray-50 rounded p-4 mb-4">
            <h3 class="text-xl font-bold text-gray-800 mb-3">Récapitulatif de la tournée</h3>
            <div class="grid grid-cols-2 gap-2">
                <div class="bg-white rounded p-2">
                    <p class="text-sm text-gray-600">Livreur</p>
                    <p class="font-semibold text-gray-900 truncate">{{ tourDetails.livreur.full_name }}</p>
                </div>
                <div class="bg-white rounded p-2">
                    <p class="text-sm text-gray-600">Tournée</p>
                    <p class="font-semibold text-gray-900 truncate">{{ tourDetails.tournee_name }}</p>
                </div>
                <div class="bg-white rounded p-2">
                    <p class="text-sm text-gray-600">Véhicule</p>
                    <p class="font-semibold text-gray-900 truncate">{{ tourDetails.camion.nom_camion }}</p>
                </div>
                <div class="bg-white rounded p-2">
                    <p class="text-sm text-gray-600">Immatriculation</p>
                    <p class="font-semibold text-gray-900 truncate">{{ tourDetails.camion.immatriculation }}</p>
                </div>
            </div>
        </div>
        
        <div class="space-y-4">
            <p class="text-base font-semibold text-gray-800 mb-2">Je confirme mon depart de tournée:</p>
            <!-- Vérifications -->
            <div class="bg-white rounded shadow-sm p-4">
                <div class="flex gap-2">
                    <Checkbox v-model="checklistConfirmed" :binary="true" class="mt-1"/>
                    <div>
                        <p class="text-base font-semibold text-gray-800 mb-2">Vérifications avant départ</p>
                        <div class="space-y-1 text-sm text-gray-700">
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Permis de conduire + Pièce d'identité (Carte d'identité ou Passeport)</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Niveau de carburant suffisant pour la tournée</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Gilet et triangle</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Diable pour le chargement</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Cageot de fruits supplémentaires</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Chargement -->
            <div class="bg-white rounded shadow-sm p-4">
                <div class="flex gap-2">
                    <Checkbox v-model="loadConfirmed" :binary="true" class="mt-1"/>
                    <div>
                        <p class="text-base font-semibold text-gray-800 mb-2">Vérification du chargement</p>
                        <div class="space-y-1 text-sm text-gray-700">
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Présence de tous les produits dans les bonnes quantités</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Bon état général des produits</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Sécurisation du chargement dans le camion</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Départ -->
            <div class="bg-white rounded shadow-sm p-4">
                <div class="flex gap-2">
                    <Checkbox v-model="vehicleConfirmed" :binary="true" class="mt-1"/>
                    <div>
                        <p class="text-base font-semibold text-gray-800 mb-2">Je m'engage à</p>
                        <div class="space-y-1 text-sm text-gray-700">
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Respecter le code de la route</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Ne prendre aucun passager étranger à la société durant ma tournée</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Ne faire aucun détour pendant la tournée</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Porter une attention particulière aux clients ayant des vigilances</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Critères prime -->
            <div class="bg-white rounded shadow-sm p-4">
                <div class="flex gap-2">
                    <Checkbox v-model="criteriaConfirmed" :binary="true" class="mt-1"/>
                    <div>
                        <p class="text-base font-semibold text-gray-800 mb-2">J'ai pris connaissance des critères pour obtenir 20€ net au titre de la prime tournée:</p>
                        <div class="space-y-1 text-sm text-gray-700">
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Totalité de la tournée effectuée</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-times-circle text-red-500 text-xs"></i>
                                <p>Pas de livraison par terre, ni devant une porte, ni dans la rue, ni couloir sauf si c'est indiqué dans les consignes de livraison uniquement</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Livraison des produits dans les locaux du client posés sur un meuble</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Pas de réclamations clients sur ma tournée (livraison ou qualité des fruits livrés)</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>Récuperer 90% ou + de cageots vides</p>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="pi pi-check-circle text-green-500 text-xs"></i>
                                <p>L'ensemble des critères ci dessus doivent être respectés pour bénéficier de la prime tournée</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Navigation -->
        <div class="flex gap-3 mt-6">
            <Button 
                label="Retour"
                icon="pi pi-arrow-left"
                severity="secondary"
                @click="$emit('prev-step')"
                class="flex-1 p-2" />

            <Button 
                label="Valider départ"
                icon="pi pi-check"
                severity="success"
                :disabled="!canValidate"
                @click="handleValidation"
                class="flex-1 p-2" />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    tourDetails: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['prev-step', 'validate-tour']);

const vehicleConfirmed = ref(false);
const criteriaConfirmed = ref(false);
const loadConfirmed = ref(false);
const checklistConfirmed = ref(false);

const canValidate = computed(() => {
    return vehicleConfirmed.value && criteriaConfirmed.value && 
           loadConfirmed.value && checklistConfirmed.value;
});

const handleValidation = () => {
    emit('validate-tour');
};
</script>